import Tooltip from '@/modules/core/components/shared/Tooltip/Tooltip'

export default Tooltip
